import React, { useContext, useEffect, useState } from "react";
import logo from "../../Logo.png";
import { IsHomePageContext } from "../Provider/IsHomePage";
import { ThemeContext } from "../Provider/ThemeProvider";

function Navbar(props) {
  const [activeButton, setActiveButton] = useState("home");
  const { setHomePage } = useContext(IsHomePageContext);
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let lastScrollTime = 0;
    const throttleDelay = 100; // ms

    const handleScroll = () => {
      const now = Date.now();
      if (now - lastScrollTime < throttleDelay) return;
      lastScrollTime = now;

      const scrollTop = window.pageYOffset;
      const isScrolled = scrollTop > 50;
      setScrolled((prev) => (prev !== isScrolled ? isScrolled : prev));

      const sections = [
        { id: "about", ref: props.aboutRef },
        { id: "skills", ref: props.skillsRef },
        { id: "experience", ref: props.experienceRef },
        { id: "portfolio", ref: props.portfolioRef },
        { id: "contact", ref: props.contactRef },
      ];

      let current = "home";
      sections.forEach((section) => {
        if (section.ref.current) {
          const offset = section.ref.current.offsetTop - 150;
          if (scrollTop >= offset) {
            current = section.id;
          }
        }
      });

      setActiveButton((prev) => {
        if (prev !== current) {
          // Only update URL and home state if current section changed
          if (current === "home") {
            window.history.replaceState(null, null, "/");
            setHomePage(true);
          } else {
            window.history.replaceState(null, null, `/${current}`);
            setHomePage(false);
          }
          return current;
        }
        return prev;
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [props.aboutRef, props.skillsRef, props.experienceRef, props.portfolioRef, props.contactRef, setHomePage]);

  const scrollToSection = (ref) => {
    const sectionTop = ref.current.offsetTop - 100;
    window.scrollTo({ top: sectionTop, behavior: "smooth" });
  };

  return (
    <nav className={`navbar navbar-expand-lg fixed-top ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container d-flex align-items-center">
        <a className="navbar-brand" href="/" onClick={(e) => { e.preventDefault(); window.scrollTo(0, 0); }}>
          <img src={logo} alt="Logo" className="logo" />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{ border: 'none', padding: '0.5rem' }}
        >
          <i className="fas fa-bars" style={{ color: "var(--text-primary)" }}></i>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto align-items-center">
            {[
              { id: "home", label: "Home", ref: null },
              { id: "skills", label: "Skills", ref: props.skillsRef },
              { id: "experience", label: "Experience", ref: props.experienceRef },
              { id: "portfolio", label: "Portfolio", ref: props.portfolioRef },
              { id: "about", label: "About", ref: props.aboutRef },
              { id: "contact", label: "Contact", ref: props.contactRef },
            ].map((item) => (
              <li className="nav-item" key={item.id}>
                <a
                  className={`nav-link ${activeButton === item.id ? "active" : ""}`}
                  href={`#${item.id}`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (item.ref) scrollToSection(item.ref);
                    else window.scrollTo(0, 0);
                  }}
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="nav-item d-flex align-items-center">
              <button
                onClick={toggleTheme}
                className="theme-toggle-btn"
                aria-label="Toggle Theme"
              >
                <i className={`fas ${isDarkMode ? 'fa-sun' : 'fa-moon'}`}></i>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
